export default {
  getBaseURL: function() {
    return this.isProduction()
      ? "https://api.athome.dtac.co.th"
      : "https://api.athome.test.dtac.co.th";
  },
  getVersion: function() {
    return "1.30";
  },
  getAdfsURL: function() {
    return this.isProduction()
      ? "https://api.athome.dtac.co.th/auth"
      : "https://api.athome.test.dtac.co.th/auth";
  },
  getWebSocketURL: function() {
    return this.isProduction()
      ? "wss://api.athome.dtac.co.th/socket/"
      : "wss://api.athome.test.dtac.co.th/socket/";
  },
  getApiKey: function() {
    return this.isProduction()
      ? "SHT-T0QRelSHSlHs59o706nJFFYvGfLr54xe"
      : "SHT-xLEtPOYgHB45MerROq43oyfmeVXjQjCfPva76cuo";
  },
  getMapKey: function() {
    return this.isProduction()
      ? "AIzaSyDBxRPJsO3tgd5sNSBnwsnPK0PlZYkr-9o"
      : "AIzaSyD3fT9NIbFzpSvM6OHu6OB7hrkwRsGIvEk";
  },
  getCdgToken: function() {
    const hostURL = window.location.hostname;
    switch (hostURL) {
      case "sale.athome.dtac.co.th":
        return "40385b93ba4d0e08f2e68f0ceb78bb6b5aae825270e54fbafdf9cf79e6800d51b49516e05fee6ea6";
      case "sale.athome.test.dtac.co.th":
        return "88efaaf9ca6267d1c26313e922191c9ef4e549409f5171b669fac8205e6444cbce6b0687d30e5eeb";
      case "localhost":
        return "3cb29afb921ed639d2bc4ce0053293a04397a868f5446bea74290352c27b87d8b8cc64decb32ce9a";
      default:
        return "";
    }
  },
  isProduction: function() {
    const hostURL = window.location.hostname;
    return hostURL === "sale.athome.dtac.co.th";
  }
};
